import {useEffect, useState} from "react";

export const WindowSize = (setMenu) =>{
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(()=>{
        function handleResize() {
            setWidth(window.innerWidth);
            if(window.innerWidth < 425){
                setMenu(true)
            }else {
                setMenu(false)
            }
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [width]);
}
